module.exports = "/_next/static/images/ourPartnersMaxxSouthLogo-ea7c2c2c7e5144e5fcb0206327750c1d.webp";